import {ethers} from 'ethers';
import {useCallback, useEffect, useState} from 'react';

const createProvider = async (url: string) => {
  const p = url.startsWith('ws')
    ? new ethers.providers.WebSocketProvider(url)
    : new ethers.providers.StaticJsonRpcProvider(url);

  await p.ready;

  return p;
};

export function useJsonRpcProvider(urlArray: string[]) {
  const [provider, setProvider] = useState<ethers.providers.JsonRpcProvider | null>(null);

  const handleProviders = useCallback(async () => {
    try {
      const p = await Promise.race(urlArray.map(createProvider));
      const _p = await p;

      setProvider(_p);
    } catch (error) {
      // todo: show notification error about provider issues
      console.log(error);
    }
  }, [urlArray]);

  useEffect(() => {
    handleProviders();
  }, [handleProviders]);

  return provider;
}
